/**
 * Created by anthony on 5/30/14.
 */
/**
 * Created by anthony on 5/30/14.
 */
var purgeService = angular.module('purgeService', []);
purgeService.service('PurgeService', function(ApplicationService, RestService, authServiceFactory, $q)
{
    return {
        purgeDependant: function(dep)
        {
            return RestService.purge("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/dependent/' + dep.recordID);
        },
        purgeChildren: function(child)
        {
            return RestService.purge("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/children/' + child.recordID);
        },
        purgeSchoolAddendum: function(school, record)
        {
            var array = []
            for(let key in record) {
                array.push(RestService.purge("/api/school/" + school + '/SchoolAddendum/' + record[key]));
            }
            return $q.all(array);
        },
        purgeTuition: function(school, record)
        {
            var array = []
            for(let key in record) {
                array.push(RestService.purge("/api/school/" + school + '/Tuition/' + record[key]));
            }
            return $q.all(array);
        },
        purgeExtraQuestion: function(school, record)
        {
            var array = [];
            for (let key in record) {
                array.push(RestService.purge("/api/school/" + school + '/ExtraQuestions/' + record[key]));
            }
            return $q.all(array);
        },
        purgeAppealQuestion: function(school, record)
        {
            var array = [];
            for (let key in record) {
                array.push(RestService.purge("/api/school/" + school + '/AppealQuestions/' + record[key]));
            }
            return $q.all(array);
        }
    }
});